<template>
  <div class="">
    <van-list v-show="!showPopup" offset="10" class="list-box">
      <van-cell v-for="(item,index) in typeList" :key="index" center is-link @click="changeType(index)">
        <template #title>
          <span class="custom-title">{{item.name}}</span>
        </template>
      </van-cell>
    </van-list>
    <van-popup v-model="showPopup" closeable position="right" :style="{ width: '100vw','height':'100vh' }"
       get-container="body">
      <div class="setting-right-content">
        <page001 v-if="showPage == 'page001'" ref="page001" @closePage="closePage"></page001>
        <page002 v-if="showPage == 'page002'" ref="page002" @closePage="closePage"></page002>
        <page003 v-if="showPage == 'page003'" ref="page003" @closePage="closePage"></page003>
        <page004 v-if="showPage == 'page004'" ref="page004" @closePage="closePage"></page004>
        <page005 v-if="showPage == 'page005'" ref="page005" @closePage="closePage"></page005>
        <page006 v-if="showPage == 'page006'" ref="page006" @closePage="closePage"></page006>
        <page007 v-if="showPage == 'page007'" ref="page007" @closePage="closePage"></page007>
        <page008 v-if="showPage == 'page008'" ref="page008" @closePage="closePage"></page008>
        <page009 v-if="showPage == 'page009'" ref="page009" @closePage="closePage"></page009>
        <page010 v-if="showPage == 'page010'" ref="page010" @closePage="closePage"></page010>
        <page011 v-if="showPage == 'page011'" ref="page011" @closePage="closePage"></page011>
        <page012 v-if="showPage == 'page012'" ref="page012" @closePage="closePage"></page012>
        <page013 v-if="showPage == 'page013'" ref="page013" @closePage="closePage"></page013>
        <page014 v-if="showPage == 'page014'" ref="page014" @closePage="closePage"></page014>
        <page015 v-if="showPage == 'page015'" ref="page015" @closePage="closePage"></page015>
        <page016 v-if="showPage == 'page016'" ref="page016" @closePage="closePage"></page016>
        <pasthistory v-if="showPage == 'pasthistory'" ref="pasthistory" @closePage="closePage"></pasthistory>
        <family v-if="showPage == 'family'" ref="family" @closePage="closePage"></family>
        <treatment v-if="showPage == 'treatment'" ref="treatment" @closePage="closePage"></treatment>
        <bq417 v-if="showPage == 'bq417'" ref="bq417" @closePage="closePage"></bq417>
        <bq422 v-if="showPage == 'bq422'" ref="bq422" @closePage="closePage"></bq422>
      </div>
    </van-popup>
  </div>
</template>

<script>
  // 引入服务组件
  import componentsModel from '../../base/components.js'
  import page001 from './page/page001'
  import page002 from './page/page002'
  import page003 from './page/page003'
  import page004 from './page/page004'
  import page005 from './page/page005'
  import page006 from './page/page006'
  import page007 from './page/page007'
  import page008 from './page/page008'
  import page009 from './page/page009'
  import page010 from './page/page010'
  import page011 from './page/page011'
  import page012 from './page/page012'
  import page013 from './page/page013'
  import page014 from './page/page014'
  import page015 from './page/page015'
  import page016 from './page/page016'
  import pasthistory from '../pasthistory/index'
  import family from '../family/index'
  import treatment from '../treatment/index'
  import bq417 from '../../bq417/form'
  import bq422 from '../../bq422/form'
  export default {
    name: "page",
    data() {
      return {
        typeList: [
        //   {
        //   name: "体格检查",
        //   router: "page001"
        // }, {
        //   name: "乙肝两对半定量",
        //   router: "page002"
        // }, {
        //   name: "乙肝病毒DNA",
        //   router: "page003"
        // }, {
        //   name: "血常规",
        //   router: "page004"
        // }, {
        //   name: "生化全套",
        //   router: "page005"
        // }, {
        //   name: "血清甲胎蛋白",
        //   router: "page006"
        // }, {
        //   name: "甲状腺功能",
        //   router: "page007"
        // }, {
        //   name: "自身抗体",
        //   router: "page008"
        // }, {
        //   name: "甲/丙/丁/戊/HIV抗体",
        //   router: "page009"
        // }, {
        //   name: "影像检查",
        //   router: "page010"
        // }, {
        //   name: "不良反应",
        //   router: "page011"
        // }, {
        //   name: "诊疗方案",
        //   router: "treatment"
        // }
        // , {
        //   name: "临床事件",
        //   router: "bq417"
        // }
        {
          name: "化验检查",
          router: "page012"
        },{
          name: "合并用药",
          router: "page014"
        }
      ],
        showPage: "page001",
        showPopup: false
      }
    },
    components: {
      ...componentsModel,
      page001,
      page002,
      page003,
      page004,
      page005,
      page006,
      page007,
      page008,
      page009,
      page010,
      page011,
      page012,
      page013,
      page014,
      page015,
      page016,
      pasthistory,
      family,
      treatment,
      bq417,
      bq422
    },
    created() {
      this.popDivContainer = document.createElement('div');
      document.body.appendChild(this.popDivContainer);
    },
    destroyed() {
      document.body.removeChild(this.popDivContainer);
      console.log(this.popDivContainer, this.popDivContainer)
    },
    methods: {
      getContainer() {
        return this.popDivContainer;
      },
      //修改类型
      changeType: function(index) {
        this.showPage = this.typeList[index].router
        this.showPopup = true
      },
      Save: function() {
        this.$refs[this.showPage].SaveInfo()
      },
      closePage: function() {
        this.showPage = ""
        this.showPopup = false
      }
    },
    mounted() {

      //判断是否基线，插入基本数据
      if (JSON.parse(sessionStorage.getItem('bq400')).bq400999 == 0) {
        // 前面推入数组
        this.typeList.unshift({
          name: "相关病史",
          router: "page013"
        }
        // , {
        //   name: "家族史",
        //   router: "family"
        // }
      )
      this.typeList.push({
          name: "治疗方案",
          router: "page015"
        })
        this.showPage = "phyicalCheck" //this.typeList[0].router
      }
      if(JSON.parse(sessionStorage.getItem('bq400')).bq400999 == 2)
      {
        this.typeList.push({
          name: "不良事件",
          router: "page016"
        })
      }


      // this.Resize()
    }
  }
</script>

<style scoped>
  .van-cell {
    height: 56px;
  }
</style>
